import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@shared/services/translate/translate.service';
import { Tab } from '@shared/models/tab/tab.class';
import { CommonUtilities } from '@shared/models/common/common-utilities.class';
import { ShopboxContainerComponent } from '@shared/components/component-schema/shopbox-container.component';
import { PageHeaderComponent } from '../../../../shared/components/v2/page-header/page-header.component';
import { RouterOutlet } from '@angular/router';


@Component({
    selector: 'shopbox-dashboard',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PageHeaderComponent, RouterOutlet]
})
export class MainComponent extends ShopboxContainerComponent {
  clientId: number;

  overviewTab: Tab = new Tab(0, 'OVERVIEW', 'overview', 'overview');
  categoryTab: Tab = new Tab(1, 'CATEGORY_SALES', 'category sales', 'category-sales');
  itemSalesTab: Tab = new Tab(2, 'ITEMS_SALES', 'items sales', 'items-sales');

    constructor(
        private _changeDetector: ChangeDetectorRef,
        public translate: TranslateService
    ) {
      super('DASHBOARD');
      this.tabs = [this.overviewTab, this.categoryTab, this.itemSalesTab];
      this.refreshTrans();
    }

    refreshTrans() {
        this.translate.onLangChanged.subscribe(() => {
            this._changeDetector.markForCheck();
        });
    }

    setGrants(grants: string) {
        if (grants.toLowerCase() === 'full') {
            this.setViewPermission(true);
            this.setEditPermission(true);
            this.setDelPermission(true);
            this.setAddPermission(true);
            this.noGrants = false;
        } else if (grants.toLowerCase() === 'partial') {
            this.setViewPermission(true);
            this.setEditPermission(false);
            this.setDelPermission(false);
            this.setAddPermission(false);
            this.noGrants = false;
        } else if (grants.toLowerCase() === 'none') {
            this.setViewPermission(false);
            this.setEditPermission(false);
            this.setDelPermission(false);
            this.setAddPermission(false);
            this.noGrants = true;
        }
    }

    setEditPermission(val: boolean): void {
      this.overviewTab.editPermission = val;
      this.categoryTab.editPermission = val;
      this.itemSalesTab.editPermission = val;
    }

    setAddPermission(val: boolean): void {
      this.overviewTab.addPermission = val;
      this.categoryTab.addPermission = val;
      this.itemSalesTab.addPermission = val;
    }

    setDelPermission(val: boolean): void {
      this.overviewTab.deletePermission = val;
      this.categoryTab.deletePermission = val;
      this.itemSalesTab.deletePermission = val;
    }

    setViewPermission(val: boolean): void {
      this.overviewTab.viewPermission = val;
      this.categoryTab.viewPermission = val;
      this.itemSalesTab.viewPermission = val;
    }

    setCurrentComponentPermission(id: number) {
        if (id === 0) {
          this.currentComponent.addPermission = this.overviewTab.addPermission;
          this.currentComponent.editPermission = this.overviewTab.editPermission;
          this.currentComponent.delPermission = this.overviewTab.deletePermission;
          this.currentComponent.viewPermission = this.overviewTab.viewPermission;
        } else if (id === 1) {
          this.currentComponent.addPermission = this.categoryTab.addPermission;
          this.currentComponent.editPermission = this.categoryTab.editPermission;
          this.currentComponent.delPermission = this.categoryTab.deletePermission;
          this.currentComponent.viewPermission = this.categoryTab.viewPermission;
        } else if (id === 2) {
          this.currentComponent.addPermission = this.itemSalesTab.addPermission;
          this.currentComponent.editPermission = this.itemSalesTab.editPermission;
          this.currentComponent.delPermission = this.itemSalesTab.deletePermission;
          this.currentComponent.viewPermission = this.itemSalesTab.viewPermission;
        }
    }

    onActivate(ev: any) {
      this.clientId = CommonUtilities.GetId();
      this.setAccess(this.name);
      this.setGrants(this.access);
      this.currentComponent = ev;
      this.currentComponent.setClientId = this.clientId;
      this.setCurrentComponentPermission(this.getActiveTab().getId);
    }

    sideBarChanged() {
        this.currentComponent.resize();
    }
}
